<template>
    <div class="">
        <modal-default ref="modalShowStaff" size="large" active-back-drop  show-footer title="Technician Details" @close="() => { staffData = ''}">

            <div v-if="!staffData" class="alert alert-info">Loading Technician Details </div>

            <div class="row" style="min-height: 600px;">
                <div class="col-md-6">
                    <iframe
                        ref="maps-iframe"
                        width="100%"
                        height="100%"
                        style="border:0"
                        loading="lazy"
                        allowfullscreen
                        referrerpolicy="no-referrer-when-downgrade"
                        src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBnMR46aA3GadB1SM05u1SSpjXhjhswz4w&q=Space+Needle,Seattle+WA">
                    </iframe>
                </div>
                <div  class="col-md-6" v-html="staffData"></div>
            </div>
        </modal-default>
    </div>
</template>

<script>
import Modal from "../../history/Modal.vue";
import ModalDefault from "../../generics/ModalDefault.vue";

export default {
    name: 'ScheduleStaffView',
    components: {ModalDefault, Modal},
    data() {
        return {
            staff: {},
            staff_id: null,
            staffData: ''
        }
    },

    mounted() {


    },

    methods: {
        getStaff(){
            this.$refs.modalShowStaff.show()

            axios.get('/users/' + this.staff_id).then((response) => {
                let result = response.data.data;
                this.staff = result;
                var address = (result.street_number ?? '') + ' ' + (result.street ?? '') + ', ' + (result.city ?? '') + ', ' + (result.state ?? '') + ', ' + (result.zipcode ?? '');
                this.staffData = '<ul class="list-group">' +
                    '<li class="list-group-item"><b>Name: </b>' + (result.name ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Email: </b>' + result.email + '</li>' +
                    '<li class="list-group-item"><b>Position: </b>' + (result.position ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Office: </b>' + (result.office ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Department: </b>' + (result.department ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Cellphone: </b>' + (result.cell ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Phone: </b>' + (result.phone ?? '') + ' ' + '<b>Ext: </b>' + (result.phone_extension ?? '') + '</li>' +
                    '<li class="list-group-item"><b>Address: </b>' + address + '</li>' +
                    '<li class="list-group-item"><b>Notes: </b><p>' + (result.notes ?? '') + '</p></li>' +
                    '</ul>';
                ;

                this.$refs["maps-iframe"].src = 'https://www.google.com/maps/embed/v1/place?key=AIzaSyBnMR46aA3GadB1SM05u1SSpjXhjhswz4w&q=' + address;

            })
        }
    }
}
</script>
<style scoped>

</style>
